import {
  TransactionScoringRequestDto,
  TransactionScoringResponseDto,
  FilterItemDto,
  TransactionDtoQueryResultDto,
  TransactionDto,
  ETransportationMode,
  TransportTypeDto,
} from 'models/dtoTypes';
import { getTransactionApi } from 'services';

export const ScoreNewTransaction = async (
  requestBody: TransactionScoringRequestDto,
): Promise<TransactionScoringResponseDto> => {
  const client = await getTransactionApi();
  const response = await client.scoreNewTransaction(requestBody);
  return response.data;
};

export const GetAllTransactionScores = async (options: {
  pageIndex: number;
  fullTextSearch?: string;
  filters?: FilterItemDto[];
  sortColumn?: string;
  isDesc?: boolean;
}): Promise<TransactionDtoQueryResultDto> => {
  const client = await getTransactionApi();
  const response = await client.getAllTransactionScores(options);
  return response.data;
};

export const getTransactionDetail = async (id: string): Promise<TransactionDto> => {
  const client = await getTransactionApi();
  const response = await client.getTransactionDetail(id);
  return response.data;
};

export const DeleteTransaction = async (id: string): Promise<void> => {
  const client = await getTransactionApi();
  await client.deleteTransaction(id);
};

export const GetLocationValues = async (
  type: ETransportationMode,
  countryCode: string,
  nameContains?: string,
): Promise<TransportTypeDto> => {
  const client = await getTransactionApi();
  const response = await client.getLocationValues(type, countryCode, nameContains);
  return response.data;
};
